import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';

interface Props {
  recordCount: number;
  numberOfPages: number;
  currentPage: number;
  setPageNumber(page: number): void;
  saveAndNext(): void;
  zoom(increase: boolean): void;
}

function Footer({
  recordCount,
  numberOfPages,
  currentPage,
  setPageNumber,
  saveAndNext,
  zoom,
}: Props) {
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(currentPage);
  }, [currentPage]);

  const handleBack = () => {
    if (currentPage > 1) {
      setPageNumber(currentPage - 1);
    }
  };

  const handleForward = () => {
    if (currentPage < numberOfPages) {
      setPageNumber(currentPage + 1);
    }
  };

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        backgroundColor: '#fff',
        padding: theme.spacing(2),
      })}>
      <Box
        sx={{
          display: 'flex',
          width: '10%',
          alignItems: 'center',
          justifyContent: 'space-around',
        }}>
        <Box>
          <RotateLeftIcon
            sx={{ width: '43px', height: '43px', cursor: 'pointer' }}
          />
          <RotateRightIcon
            sx={{ width: '43px', height: '43px', cursor: 'pointer' }}
          />
        </Box>
        <Box>
          <ZoomOutIcon
            sx={(theme) => ({
              width: '43px',
              height: '43px',
              cursor: 'pointer',
              color: theme.palette.primary.main,
            })}
            onClick={() => zoom(false)}
          />
          <ZoomInIcon
            sx={(theme) => ({
              width: '43px',
              height: '43px',
              cursor: 'pointer',
              color: theme.palette.primary.main,
            })}
            onClick={() => zoom(true)}
          />
        </Box>
        {numberOfPages > 1 && (
          <Typography variant="body1">
            Page {page} of {numberOfPages}
          </Typography>
        )}
        {numberOfPages > 1 && (
          <Box>
            <ChevronLeftIcon
              sx={{ width: '43px', height: '43px', cursor: 'pointer' }}
              onClick={handleBack}
            />
            <ChevronRightIcon
              sx={{ width: '43px', height: '43px', cursor: 'pointer' }}
              onClick={handleForward}
            />
          </Box>
        )}
      </Box>
      <Typography
        variant="body1"
        sx={{
          width: '80%',
          display: 'flex',
          justifyContent: 'center',
        }}>
        {recordCount} Items
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'right',
          width: '10%',
        }}>
        <Button
          sx={(theme) => ({ marginRight: theme.spacing(2) })}
          variant="outlined"
          size="large"
          color="primary">
          Close
        </Button>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={saveAndNext}>
          Save and Next
        </Button>
      </Box>
    </Box>
  );
}

export default Footer;
